import { forwardRef } from "react";
import { cn } from "../lib/utils";

export const GhostButton = forwardRef(function GhostButton(
  { className, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center gap-2",
        "rounded-full px-5 py-2.5 text-sm font-medium",
        "text-white/85 border border-white/15 bg-white/[0.03]",
        "backdrop-blur-md",
        "transition-colors duration-200",
        "hover:text-white hover:bg-white/[0.07] hover:border-white/25",
        "active:bg-white/[0.05]",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
});

export default GhostButton;
